export default __webpack_public_path__ + "static/media/rjlogosm.92a83955.png";